module.exports = __webpack_public_path__ + "img/Advantage_icon03.47c4c6d4.png";